export default "__VITE_ASSET__2e2d5d10__"